import { createSelector } from 'reselect';
import { APP_RESET } from '../App/constants';

/**
 * Who has the game open right now: the players in the game's presence channel (services/pusher), by user id. For the
 * opponent's online dot.
 */
export const SET_ONLINE = 'PRESENCE/SET_ONLINE';

export const setOnline = (gameId, userIds) => ({
  type: SET_ONLINE,
  payload: { gameId, userIds },
});

export function reducer(state = { gameId: null, userIds: [] }, action) {
  switch (action.type) {
    case SET_ONLINE:
      return action.payload;
    case APP_RESET:
      return { gameId: null, userIds: [] };
    default:
      return state;
  }
}

/** Whether `userId` has game `gameId` open right now. */
export const selectIsOnline = createSelector(
  [(state) => state.presence, (state, { gameId }) => gameId, (state, { userId }) => userId],
  (presence, gameId, userId) => presence.gameId === gameId && presence.userIds.includes(userId),
);
